<template>
  <div>
    <div class="content-header">
      <h1>Zákazníci</h1>
    </div>
    <section class="content">
      <div class="box">
        <div class="box-header">
          <button class="btn btn-success btn-sm" @click.prevent="createShow()"><i class="fa fa-plus"></i> Pridať zákazníka</button>
          <div class="box-tools">
            <div class="input-group input-group-sm input-search hidden-xs">
              <input type="text" v-model="query" class="form-control pull-right" placeholder="Vyhľadaj podľa názvu.">

              <div class="input-group-btn">
                <button type="submit" class="btn btn-default"><i class="fa fa-search"></i></button>
              </div>
            </div>
          </div>
        </div>
        <customer-create-modal :show-model="showCreateModal" :model="selectedCustomer" @close="hideModals()"></customer-create-modal>
        <customer-detail-modal :show-model="showDetailModal" :model="selectedCustomer" @close="hideModals()"></customer-detail-modal>

        <div class="box-body">
          <div class="row" v-if="customers.length">
            <div class="col-md-12">
              <table class="table table-hover">
                <thead>
                <tr>
                  <th><a href="" @click.prevent="sort('companyName')">Názov <i class="fa fa-chevron-circle-up" v-if="sortBy === 'companyName'"></i></a></th>
                  <th>Druh</th>
                  <th>Oblasť</th>
                  <th>Adresa</th>
                  <th>Nadradený</th>
                  <th><a href="" @click.prevent="sort('sortOrder')">Poradie v rozvoze <i class="fa fa-chevron-circle-up" v-if="sortBy === 'sortOrder'"></i></a></th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <template v-for="customer in customers">
                  <tr :class="{inactive : !customer.active}">
                    <td>{{ customer.companyName }}</td>
                    <td>{{ customer.businessType | codeListValue(businessTypes) }}</td>
                    <td>{{ customer.area.label }}</td>
                    <td>{{ customer.address.format() }}</td>
                    <td>{{ customer.parent ? customer.parent.companyName : '' }}</td>
                    <td>{{ customer.sortOrder }}</td>
                    <td class="text-right text-nowrap">
                      <button class="btn btn-xs btn-link" @click.prevent="showCustomer(customer)"><i class="fa fa-2x fa-eye text-primary" title="Zobraziť"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="editCustomer(customer)"><i class="fa fa-2x fa-pencil-square-o text-primary" title="Editovať"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="toggleActivate(customer)"><i :class="{'fa-toggle-on': customer.active, 'fa-toggle-off text-success': !customer.active}" class="fa fa-2x" :title="customer.active ? 'Deaktivovať' : 'Aktivovať'"></i></button>
                      <button class="btn btn-xs btn-link" @click.prevent="deleteCustomer(customer)"><i class="fa fa-2x fa-times text-danger" title="Zmazať"></i></button>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
          <loading id="customers"></loading>
          <no-records :data="customers" loadingId="customers"></no-records>
        </div>
      </div>
    </section>
  </div>

</template>

<script>
  import _ from 'lodash';
  import { normalize } from 'utils';
  import { alert } from 'vue-strap';
  import { mapState } from 'vuex';
  import { businessTypes } from 'codelist/';
  import loading from 'components/loading';
  import noRecords from 'components/noRecords';
  import customerCreateModal from 'components/customerCreateModal';
  import customerDetailModal from 'components/customerDetailModal';
  import notificationService from 'services/notificationService';
  import customerService from 'services/customerService';

  export default {
    components: {alert, customerCreateModal, customerDetailModal, loading, noRecords},
    data: () => ({
      businessTypes: businessTypes,
      showCreateModal: false,
      showDetailModal: false,
      selectedCustomer: null,
      sortBy: 'companyName',
      query: null
    }),
    computed: mapState({
      customers(state) {
        let allCustomers = _(state.customer.items);
        if (this.query) {
          let regexp = new RegExp(normalize(this.query), "g");
          allCustomers = allCustomers.filter(item => !!normalize(item.companyName).match(regexp));
        }

        return allCustomers.sortBy(this.sortBy).value();
      }
    }),
    methods: {
      createShow () {
        this.selectedCustomer = customerService.newCustomer();
        this.showCreateModal = true;
      },
      hideModals () {
        this.showCreateModal = false;
        this.showDetailModal = false;
      },
      toggleActivate (customer) {
          if (customer.active) {
            this.$store.dispatch('customer/deactivate', customer.id).then((result) => {
              if (result) {
                notificationService.success('Zákazník bol deaktivovaný.');
              }
            });
          } else {
            this.$store.dispatch('customer/activate', customer.id).then((result) => {
              if (result) {
                notificationService.success('Zákazník bola aktivovaný.');
              }
            });
          }
      },
      deleteCustomer (customer) {
        this.confirm('customer.delete.confirmation', [customer.companyName]).then(() => {
          this.$store.dispatch('customer/delete', customer.id).then((result) => {
            if (result) {
              notificationService.success('Zákazník bol zmazaný.');
            }
          }).catch(this.unprotect);
        }).catch(this.unprotect);
      },
      editCustomer (customer) {
        this.selectedCustomer = _.cloneDeep(customer);
        this.showCreateModal = true;
      },
      sort (sortBy) {
          this.sortBy = sortBy;
      },
      async showCustomer (customer) {
        this.selectedCustomer = _.cloneDeep(customer);
        this.$store.dispatch('priceList/setFilterCustomerId', customer.id);
        await this.$store.dispatch('priceList/findCurrent');
        this.showDetailModal = true;
      }
    },
    created () {
      this.$store.dispatch('customer/getAll')
    }
  }
</script>



// WEBPACK FOOTER //
// client/views/customers.vue